import {ExportHtmlStatus} from "@dropDesk/domain/entities/ticket/ticket_maps";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";

export class ExportTicketStatusEntity {
    idTicket!: string;
    idCompany!: string;
    createdAt!: string;
    tickerNumber!: number;
    status!: ExportHtmlStatus;
    roleAllowed!: UserRole;
    url!: string | null;
    progress!: number;
    page!: number;
    limit!: number;

    public get inProgress(): boolean {
        return this.status === ExportHtmlStatus.inProgress;
    }

    public get done(): boolean {
        return this.status === ExportHtmlStatus.done;
    }

    public get error(): boolean {
        return this.status === ExportHtmlStatus.error;
    }

    public get canceled(): boolean {
        return this.status === ExportHtmlStatus.canceled;
    }

    constructor(partial: Partial<ExportTicketStatusEntity>) {
        Object.assign(this, partial);
        this.page = this.page ?? 0;
        this.limit = this.limit ?? 100;
    }

    static fromJson(json: any): ExportTicketStatusEntity {
        return new ExportTicketStatusEntity(json);
    }
}
